<div class="flex flex-1 flex-col align-top">
  <div class="flex flex-1 flex-row text-left">
    <mat-icon class="mr-1" [color]="data.color">{{data.icon}}</mat-icon>
    <span class="text-center text-black font-bold">{{data.descripcion}}</span>
  </div>
  <div class="flex flex-1 flex-col">
    <div class="flex flex-1 mx-auto">
      <button mat-icon-button (click)='close()' [color]="data.color">{{data.button}}</button>
    </div>
  </div>
</div>
